<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1000px" top="5vh" :close-on-click-modal="false" :before-close="handleClose">
        <!-- 步骤条 -->
        <div class="step-bar">
            <div :class="['bar-item', {'active': stepActive === item.id, 'completed': item.id < currentStep}]" v-for="item in stepList" :key="item.id"
                @click="changeStep(item.id)">
                <!-- 已完成的步骤 显示勾icon -->
                <template v-if="item.id < currentStep || (item.id === currentStep && currentStep === 4)">
                    <img v-if="stepActive === item.id" src="@/assets/image/requirement/icon-complete-white.png">
                    <img v-else src="@/assets/image/requirement/icon-complete.png">
                </template>
                <!-- 未完成的步骤 显示其icon -->
                <template v-else>
                    <img :src="stepActive === item.id ? item.imgWhite : item.imgsrc" alt="">
                </template>
                <span>{{ item.name }}</span>
            </div>
        </div>
        <!-- 内容 -->
        <step1 v-if="stepActive === 1" ref="step1Dom" :type="type" :requirementId="requirementId" :currentStep="currentStep" @push="handlePush(2, $event)" />
        <step2 v-else-if="stepActive === 2" ref="step2Dom" :type="type" :requirementId="requirementId" :currentStep="currentStep" @push="handlePush(3)"
            @rollback="handleRollback(1)" />
        <step3 v-else-if="stepActive === 3" ref="step3Dom" :type="type" :requirementId="requirementId" :currentStep="currentStep" @push="handlePush(4)"
            @rollback="handleRollback(2)" />
        <step4 v-else-if="stepActive === 4" ref="step4Dom" :type="type" :requirementId="requirementId" :currentStep="currentStep" @push="handlePush(5)"
            @rollback="handleRollback(3)" />
        <step5 v-else-if="stepActive === 5" ref="step5Dom" :type="type" :requirementId="requirementId" :currentStep="currentStep" @close="handleClose"
            @rollback="handleRollback(4)" />
    </el-dialog>
</template>

<script>
import { pushRequirement, rollbackRequirement } from '@/api/requirement'

export default {
    components: {
        step1: () => import('./step1.vue'),
        step2: () => import('./step2.vue'),
        step3: () => import('./step3.vue'),
        step4: () => import('./step4.vue'),
        step5: () => import('./step5.vue')
    },
    props: {
        visible: Boolean,
        editItem: Object,
        // 弹窗类型：add 新增 | edit 编辑 | preview 预览
        type: String,
    },
    watch: {
        visible: {
            handler(val) {
                this.dialogVisible = val;
                if (val) {
                    // 弹窗打开
                    if (this.type === 'edit' || this.type === 'preview') {
                        // 编辑
                        this.title = this.editItem.title;
                        this.requirementId = this.editItem.id;
                        this.currentStep = this.editItem.node;
                        this.stepActive = this.editItem.node;
                        this.initPage(this.editItem.node);
                    } else if (this.type === 'add') {
                        // 新增
                        this.title = '新增需求';
                        this.requirementId = null;
                        this.currentStep = 1;
                        this.stepActive = 1;
                        this.$nextTick(() => {
                            this.$refs.step1Dom?.clearForm();
                        })
                    }
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            title: '',
            dialogVisible: false,
            requirementId: null, // 需求id
            currentStep: 0, // 当前的进度执行到了哪一步
            stepActive: 1, // 当前显示的步骤
            stepList: [
                { id: 1, name: '提出需求', imgsrc: require("@/assets/image/requirement/icon-step1.png"), imgWhite: require("@/assets/image/requirement/icon-step1.png") },
                { id: 2, name: '会议评估', imgsrc: require("@/assets/image/requirement/icon-step2.png"), imgWhite: require("@/assets/image/requirement/icon-step2-white.png") },
                { id: 3, name: '功能开发', imgsrc: require("@/assets/image/requirement/icon-step3.png"), imgWhite: require("@/assets/image/requirement/icon-step3-white.png") },
                { id: 4, name: '销售评价', imgsrc: require("@/assets/image/requirement/icon-step4.png"), imgWhite: require("@/assets/image/requirement/icon-step4-white.png") },
                { id: 5, name: '已完成', imgsrc: require("@/assets/image/requirement/icon-step5.png"), imgWhite: require("@/assets/image/requirement/icon-step5-white.png") },
            ]
        }
    },
    methods: {
        // 切换
        changeStep(step) {
            if (step <= this.currentStep) {
                this.initPage(step);
            }
        },
        // 加载页面内容
        initPage(node) {
            this.stepActive = node;
            if (this.stepActive === 1) {
                this.$nextTick(() => {
                    this.$refs.step1Dom?.echoInfo();
                })
            } else if (this.stepActive === 2) {
                setTimeout(() => {
                    this.$refs.step2Dom?.echoInfo();
                }, 100)
            } else if (this.stepActive === 3) {
                setTimeout(() => {
                    this.$refs.step3Dom?.echoInfo();
                }, 100)
            } else if (this.stepActive === 4) {
                setTimeout(() => {
                    this.$refs.step4Dom?.echoInfo();
                }, 100)
            }
        },
        handleClose() {
            this.$emit('close')
        },
        // 推进
        handlePush(step, requirementId = null) {
            pushRequirement({ requirementId: requirementId ? requirementId : this.requirementId }).then(() => {
                if (requirementId) {
                    this.requirementId = requirementId;
                }
                this.currentStep = step;
                this.initPage(step);
            }).catch(err => {
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 回退
        handleRollback(step) {
            rollbackRequirement({ requirementId: this.requirementId }).then(() => {
                this.currentStep = step;
                this.initPage(step);
            }).catch(err => {
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.step-bar {
    display: flex;
    margin-top: -20px;
    margin-bottom: 30px;
    .bar-item {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 25%;
        height: 40px;
        background-color: #edeef4;
        font-size: 15px;
        cursor: pointer;
        img {
            width: 16px;
        }
        &.active {
            color: #fff !important;
            background-color: #0540c3 !important;
            &::after {
                border-left-color: #0540c3 !important;
            }
        }
        &.completed {
            color: #0540c3;
            background: #dae3f6;
            &::after {
                border-left-color: #dae3f6;
            }
        }
        &::after {
            position: absolute;
            top: 0;
            right: -12px;
            content: "";
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-left: 12px solid #edeef4;
            border-bottom: 20px solid transparent;
            z-index: 1;
        }
        &:last-of-type {
            &::after {
                display: none;
            }
        }
    }
}
</style>